import React from 'react'

const TripsPrivate = () => (
  <article>
    <h2>Exhibitions</h2>
    <p>
      Please note: a ready-to-hang exhibition titled COLD PLACES: PICTURES FROM
      THE POLES is available for hire. To find out more, please email{' '}
      <a href="mailto:info@sueflood.com">info@sueflood.com</a>
    </p>
  </article>
)

export default TripsPrivate
